// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__1uqgi","video-box":"Video_video-box___HUYz","video-rate-control":"Video_video-rate-control__3_4j8","video-close":"Video_video-close__3eQRP"};